import { InvalidUIDError } from 'Utils/errors';

export const isUIDValid = (uid) => {
  if (/^[0-9]+$/.test(uid) && Number.isInteger(parseInt(uid, 10))) {
    return true;
  }
  throw new InvalidUIDError();
};
